import { render } from "./p-checkbox-group.vue?vue&type=template&id=4c1ed202"
import script from "./p-checkbox-group.vue?vue&type=script&lang=js"
export * from "./p-checkbox-group.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-checkbox-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c1ed202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c1ed202', __exports__)) {
    api.reload('4c1ed202', __exports__)
  }
  
  module.hot.accept("./p-checkbox-group.vue?vue&type=template&id=4c1ed202", () => {
    api.rerender('4c1ed202', render)
  })

}


export default __exports__